angular.module('impactx.search').component('ixLotItem', {
        bindings: {
            lot: '<'
        },
        require: {
            listCtrl: '^^ixLotList'
        },
        controller: 'LotItemCtrl',
        controllerAs: 'itemCtrl',
        templateUrl: 'modules/search/templates/lot-item.html'
    }
);